import { ActionEventsEnum } from "../enum/tracking/action-events.enum";
import { TrackingActions } from "../state-management/tracking/tracking.action";
import { Advisor, AdvisorTypeEnum } from "../models/Advisor";

export class AdvisorEntity implements Advisor {
    constructor(private advisor: Advisor) { }

    public get type() {
        return this.advisor.type
    }
    public get name() {
        return this.advisor.name
    }
    public get email() {
        return this.advisor.email
    }
    public get phone() {
        return this.advisor.phone
    }
    public get mobilePhone() {
        return this.advisor.mobilePhone
    }
    public get profilePictureUrl() {
        return this.advisor.profilePictureUrl
    }
    public get onVacation() {
        return this.advisor.onVacation
    }
    public get typeDescription() {
        return this.advisor.typeDescription
    }
    public get attendanceDescription() {
        return this.advisor.attendanceDescription
    }
    public get whatsapp() {
        return this.advisor.whatsapp
    }
    public get calendly() {
        return this.advisor.calendly
    }

    public get phoneByType() {
        return this.type === AdvisorTypeEnum.EXCLUSIVE ? this.mobilePhone : this.phone;
    }

    // TODO: Levar para o GraphQL
    public get about() {
        if (this.advisor.about) return this.advisor.about;

        if (this.type === AdvisorTypeEnum.EXCLUSIVE) return {
            title: 'Cuidamos do seus investimentos para você.',
            content: 'Na conta Exclusiva, você tem um Assessor dedicado a te ajudar em tudo o que precisa.',
        }

        if (this.type === AdvisorTypeEnum.AAI) return {
            title: 'Atendimento especializado.',
            content: 'Conte com seu Agente Autônomo para ajudar nos seus investimentos e tirar dúvidas.',
        }
    }


    public getAnalyticsEvent(
        action: ActionEventsEnum,
        element: string,
        customProps: Record<string, any> = {},
    ) {
        return {
            type: TrackingActions.trackEvents,
            payload: {
                type: action,
                events: {
                    element,
                    advisor: this.advisor.name,
                    advisor_type: this.advisor.type,
                    ...customProps
                }

            },
        };
    }
}